<template>
    <div id="failRecord" class="background-ash pl20 pr20 pb20" >
       <div class="search_list background-white">
		   <ul class="lists">
                <li>
                    <span>商品名称</span>
                    <el-input size="small" class="width180" @keyup.native.enter="searchGetDataList" v-model="getDataParam.nameLike" placeholder="请输入商品名称"></el-input>
                </li>
                <li>
                    <span>批准文号</span>
                    <el-input size="small" class="width180" @keyup.native.enter="searchGetDataList" v-model="getDataParam.licenseNumber" placeholder="请输入批准文号"></el-input>
                </li>
                <li>
                    <span>失败原因</span>
                    <el-select size="small" class="select width100" v-model="getDataParam.failCode" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option v-for="item in failResultList" :key="item.failCode" :label="item.failDesc" :value="item.failCode"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns">
                <el-button size="small" type="primary"  @click="searchGetDataList">搜索</el-button>
            </div>
	   </div>
       <!--内容-->
       <div class="pt20 content">
           <!--表头操作-->
           <div class="watchBar">
               <div class="total-user left color-blue">比价失败商品{{totalCount}}个</div>
               <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
                </div>
           </div>
           <!--表格-->
           <div class="tab">
               <el-table ref="checkList" :row-key="getRowKey" @selection-change="handleSelectionChange" size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                   <el-table-column type="selection" width="50" fixed :reserve-selection="true"></el-table-column>
                   <el-table-column label="序号" type="index"></el-table-column>
                   <el-table-column label="商品名称" >
                        <template slot-scope="scope">{{ scope.row.name || '' }}</template>
                    </el-table-column>
                    <el-table-column label="批准文号" prop="licenseNumber"></el-table-column>
                    <el-table-column label="规格" prop="specifications"></el-table-column>
                    <el-table-column label="厂家" prop="manufactur"></el-table-column>
                    <el-table-column label="失败原因" prop="failDesc"></el-table-column>
               </el-table>
           </div>
           <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList" :current-page.sync="getDataParam.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
       </div>
    </div>
</template>

<script>
export default {
	name: 'failRecord', //失败记录
	data () {
		return {
			getDataParam: {
				compareRecordId: null,
                nameLike: '',
                licenseNumber: '',
                failCode:'all',
				page:1,
				size:10
            },
            failResultList: [],
            dataList: [],
            checkList: [],
            totalCount:0,
            loading: false,
		}
	},
	watch: {},
	methods: {
		searchGetDataList () {
            this.$refs.checkList.clearSelection();
            this.getDataParam.page = 1;
            this.getDataList();
        },
        //获取数据
        getDataList () {
            let param = {...this.getDataParam};
            if (param.failCode === 'all') {
                param.failCode = null;
            }
            param.page = (param.page - 1);
            const loading = this.load();
            this.$http('POST', '/admin/auto/result/pageOfFail', {}, param, (status, res) => {
                loading.close();
                if (status) {
                   if(!!res.content && res.content.length > 0) {
                       this.dataList = res.content;
                   }else {
                       this.dataList = [];
                   }
                   this.totalCount = res.totalCount;
                }
            })
        },
        getFailResult() {
            this.$http('POST', '/admin/auto/result/getFailCode', {}, {}, (status, res) => {
                if (status) {
                   if(!!res.data && res.data.length > 0) {
                       this.failResultList = res.data;
                   }else {
                       this.failResultList = [];
                   }
                }
            });
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        handleSelectionChange (select) {
            console.log('selelct,,,,,',select);
            this.checkList = select.map( (item) => { return item.id});
        },
        getExport () {
            let param = {
                compareRecordId: this.getDataParam.compareRecordId,
                ids: this.checkList,
                nameLike: this.getDataParam.nameLike,
                licenseNumber: this.getDataParam.licenseNumber
            };
            if (param.ids <= 0) {
                param.ids = null;
            }
            if (param.failCode === 'all') {
                param.failCode = null;
            }
            const loading = this.load();
            this.$http('POST', '/admin/auto/result/exportOfFail', {}, param, (status, res) => {
                loading.close();
                if (status) {
                   if (res.status === '200') {
                       this.educe(res.data);
                   }
                }
            })
        },
        //勾选复选框
        getRowKey (row) {
            return row.id
        },

	},
	mounted () {
        this.getDataParam.compareRecordId = this.$route.query.id;
        this.getDataList();
        this.getFailResult();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#failRecord {width: 100%;height: calc(100vh - 155px);}
#failRecord .content {height: calc(100% - 91px);}
#failRecord .content .tab {height: calc(100% - 125px);}
#failRecord >>>.el-table th.type>.cell, #userList >>>.el-table td.type>.cell {margin-left: 75px;}
#failRecord >>>.width400.el-input{width: 400px; height: 36px; border-radius: 2px;}
#failRecord >>>.width400.el-input .el-input__inner{width: 400px; height: 36px; border-radius: 2px;}
</style>



// WEBPACK FOOTER //
// src/views/automaticParity/failRecord.vue